<script>
export default {
  props: {
    xsmall: {
      type: Boolean,
      default: false,
    },
    xs: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    cSize() {
      if (this.xlarge || this.xl) {
        return 'xlarge';
      }
      if (this.large || this.lg) {
        return 'large';
      }
      if (this.medium || this.md) {
        return 'medium';
      }
      if (this.small || this.sm) {
        return 'small';
      }
      if (this.xsmall || this.xs) {
        return 'xsmall';
      }
      if (this.legoInput) {
        return this.legoInput.size;
      }
      return this.default.size;
    },
  },
};
</script>
<style lang="scss" scoped>
.lego-button--small {
  @include font($lego-button__font-size--small);
  border-radius: 2px;
}
.lego-button--medium {
  @include font($lego-button__font-size--medium);
  border-radius: 3px;
}
.lego-button--large {
  @include font($lego-button__font-size--large);
  border-radius: 4px;
}
@each $_name, $_color in $lego-button__colors {
  @include makeButtonColorPreset($_name);
}

.lego-button--disabled.lego-button--solid.lego-button--primary {
  color: $color--ui-white !important;
  border-color: $color--primary-tint03 !important;
  background-color: $color--primary-tint03 !important;
}
.lego-button--solid.lego-button--primary {
  font-weight: 700;
}
.lego-button--disabled.lego-button--border {
  color: $color--ui07 !important;
  border-color: $color--ui07 !important;
  background-color: $color--ui-white !important;
}
.lego-button--disabled.lego-button--border.lego-button--primary {
  color: $color--primary-tint03 !important;
  border-color: $color--primary-tint03 !important;
  background-color: $color--ui-white !important;
}
</style>
